import TrendedIcon from "@assets/icons/mode/trends.svg?react";
import PointInTimeIcon from "@assets/icons/mode/point_in_time.svg?react";
import PrePostIcon from "@assets/icons/mode/pre_post.svg?react";
import {
  MAXIMUM_ALLOWED_QUESTIONS_IN_TRENDS,
  POINT_IN_TIME,
  PRE_POST,
  TREND,
} from "@/constant/constantsThrougoutProject";

const MODE_OPTIONS = [
  {
    value: TREND,
    label: "Trended",
    icon: <TrendedIcon height={18} width={18} />,
    infoText:
      `This option is not available for more than ${MAXIMUM_ALLOWED_QUESTIONS_IN_TRENDS} question selected.`,
  },
  {
    value: POINT_IN_TIME,
    label: "Point-In-time",
    icon: <PointInTimeIcon height={18} width={18} />,
  },
  {
    value: PRE_POST,
    label: "Pre/Post",
    icon: <PrePostIcon height={18} width={18} />,
  },
];

export { MODE_OPTIONS };
